import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class DialogNavigationService {

  constructor(private router: Router) {}

  /**
   * Navega a una ruta después de cerrar completamente un dialog
   * @param dialogRef - Referencia del dialog a cerrar
   * @param route - Ruta a la que navegar
   * @param queryParams - Parámetros de consulta opcionales
   */
  navigateAfterClose(
    dialogRef: MatDialogRef<any>, 
    route: string | any[], 
    queryParams?: any
  ): void {
    dialogRef.afterClosed().subscribe(() => {
      if (Array.isArray(route)) {
        this.router.navigate(route, { queryParams });
      } else {
        this.router.navigate([route], { queryParams });
      }
    });
    dialogRef.close();
  }
}